module.exports = {imjoyRPC: require('./dist/imjoy-rpc.js'), imjoyRPCSocketIO: require("./dist/imjoy-rpc-socketio")};